import ETable from './table.jsx'

ETable.install = function(Vue) {
  Vue.component(ETable.name, ETable)
}

export default ETable